export default "__VITE_ASSET__Bd$mGsSp__"